:root {
  color: #232323;
  background: #f5f6f4;
  font-family:
    Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

html {
  scrollbar-gutter: stable;
}

button,
input {
  font: inherit;
}

@layer priority1 {
  button {
    background-color: transparent;
    background-image: none;
  }
}

button,
a,
input[type='checkbox'] {
  -webkit-tap-highlight-color: transparent;
}
